export const onElementRendered = (
  wrapper: HTMLElement,
  targetElement: HTMLElement,
  onRender: () => void,
) => {
  const observer = new MutationObserver(() => {
    if (
      wrapper.contains(targetElement) &&
      targetElement.offsetWidth > 0 &&
      targetElement.offsetWidth < document.body.offsetWidth
    ) {
      onRender();
      observer.disconnect();
    }
  });

  observer.observe(document, {
    attributes: false,
    childList: true,
    characterData: false,
    subtree: true,
  });
};
